import type { IconData } from '@stacksjs/iconify-core'

export const contentCalendar: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.06.65H2.12v1.96H.16v12.74h15.68V2.61h-1.96V.65h-2.94v1.96H5.06zm7.35 10.043a1.227 1.227 0 1 0 0 2.454a1.227 1.227 0 0 0 0-2.454\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentCalendar
